/**
 * Domínios cujos hosts este app aceita usar.
 *
 * É o controle que limita o dano se o serviço de config for comprometido: sem
 * ele, um payload malicioso redirecionaria TODO o tráfego de API do app para um
 * host arbitrário. O serviço tem a própria cópia desta lista como portão de CI,
 * mas o app não pode confiar nela — a verificação que vale é esta, no cliente.
 */
const SUFIXOS_PERMITIDOS = [
  'actuar.cloud',
  'toletus.cloud',
  'actuar.com',
  'actuar.dev',
  'trei.no',
  'pague.la',
];

/**
 * `valor` pode trazer prefixo de path junto do host (ex.: '…actuar.cloud/Odata'),
 * porque `url()` sempre concatenou host e path cruamente — só a parte antes da
 * primeira barra é comparada.
 *
 * A comparação é ancorada em ponto: um `endsWith` cru aceitaria 'notpague.la'.
 */
export function hostPermitido(valor: string): boolean {
  if (typeof valor !== 'string' || valor.length === 0) return false;

  const host = valor.split('/')[0].toLowerCase();
  if (host.length === 0) return false;

  return SUFIXOS_PERMITIDOS.some((s) => host === s || host.endsWith(`.${s}`));
}

/**
 * Terceiros, por host EXATO — não por sufixo.
 *
 * O rigor extra é deliberado: um sufixo `apple.com` autorizaria qualquer
 * subdomínio da Apple, e este é o campo por onde um payload adulterado tentaria
 * escapar. Estes endereços nunca recebem tráfego de API — são links de saída, um
 * lookup de IP e o script de fingerprint do provedor de pagamento.
 */
const HOSTS_EXTERNOS_PERMITIDOS = [
  'apps.apple.com',
  'play.google.com',
  'api.ipify.org',
  'h.online-metrix.net',
  'www.youtube.com',
  'facebook.com',
  'twitter.com',
  'www.instagram.com',
];

/** Igualdade exata, sem sufixo: ver o comentário acima. */
export function hostExternoPermitido(valor: string): boolean {
  if (typeof valor !== 'string' || valor.length === 0) return false;

  const host = valor.split('/')[0].toLowerCase();
  return HOSTS_EXTERNOS_PERMITIDOS.some((permitido) => host === permitido);
}
